import { DocumentStatusOption } from '../constants'
import UpdateDocumentStatus from '../../queries/UpdateDocumentStatus'
import { useMutation } from '@apollo/react-hooks'
import { useSnackbar } from '../../contexts/SnackbarContext'
import Documents from '../../queries/DocumentsQuery'
import useDocumentOwnership from './useDocumentOwnership'
import {
  generateNewCacheDataExludingDocument,
  generateNewCacheDataAddingDocument,
} from '../utils/apollo-cache-manipulation'

function useUpdateDocumentStatus() {
  const { loanId, getEntityOnwer } = useDocumentOwnership()
  const { setErrorMessage } = useSnackbar()

  const [updateStatusMutation, { loading }] = useMutation(
    UpdateDocumentStatus,
    {
      onError: () =>
        setErrorMessage('There was an error updating the document status'),
    }
  )

  const updateStatus = ({ documentId, newStatus }) => {
    updateStatusMutation({
      variables: {
        input: {
          documentId,
          status: newStatus,
        },
      },
      update: (cache, mutationResult) => {
        const shouldMutateCache = [
          DocumentStatusOption.move_to_archived,
          DocumentStatusOption.un_archive,
        ].includes(newStatus)
        if (!shouldMutateCache) return

        const cacheData = cache.readQuery({
          query: Documents,
          variables: { rid: loanId },
        })

        const updatedDocument =
          mutationResult.data.updateDocumentStatus.document

        let newCacheData = cacheData

        newCacheData = generateNewCacheDataExludingDocument({
          cacheData: newCacheData,
          documentId: updatedDocument.rid,
        })

        newCacheData = generateNewCacheDataAddingDocument({
          cacheData: newCacheData,
          newDocument: updatedDocument,
          owner: getEntityOnwer(documentId),
          isArchived: newStatus === DocumentStatusOption.move_to_archived,
        })

        cache.writeQuery({
          query: Documents,
          variables: { rid: loanId },
          data: newCacheData,
        })
      },
    })
  }

  return { updateStatus, loading }
}

export default useUpdateDocumentStatus
